import { render, staticRenderFns } from "./callCenter.vue?vue&type=template&id=3c68f5bd&scoped=true"
import script from "./callCenter.vue?vue&type=script&lang=js"
export * from "./callCenter.vue?vue&type=script&lang=js"
import style0 from "./callCenter.vue?vue&type=style&index=0&id=3c68f5bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68f5bd",
  null
  
)

export default component.exports